import { render, staticRenderFns } from "./NoticeOfUsageSG.vue?vue&type=template&id=2d2f47a7&scoped=true&"
import script from "./NoticeOfUsageSG.vue?vue&type=script&lang=js&"
export * from "./NoticeOfUsageSG.vue?vue&type=script&lang=js&"
import style0 from "./NoticeOfUsageSG.vue?vue&type=style&index=0&id=2d2f47a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f47a7",
  null
  
)

export default component.exports